export function offeringAnalysisContext(type:string,name:string,description:string){
 return type==='software'||type==='service'?{type,name,description}:undefined;
}
/** Only untouched blanks accept suggestions; clearing a field is also an edit. */
export function fillOfferingSuggestion<T extends string|string[]>(current:T,initial:T,suggestion:T,revision:number,initialRevision:number):T{
 const blank=(value:T)=>typeof value==='string'?!value.trim():value.length===0;
 return revision===initialRevision&&blank(initial)&&blank(current)?suggestion:current;
}

export function offeringAnalysisInputHint(type:string,url:string,name:string){
 if(!url.trim())return 'Enter a URL to analyze.';
 return '';
}
export function hasUnsavedOfferingType(saved:string|undefined,draft:string){return draft!==(saved??'unknown');}

export function productImageImportMessage(missing: boolean, existingPhotoCount: number): string {
 if (!missing) return '';
 return existingPhotoCount > 0
  ? 'Sorry, we’re unable to import new product images. Your existing images are preserved. You can upload more below.'
  : 'Sorry, we’re unable to import your product images. Please upload them below.';
}

export function offeringScanContext(type:import('@shared/offering').OfferingType,name:string,description:string){return {type,name,description};}
